var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      ref: "appLayout",
      attrs: { page: "/upload-image", pageTitle: "Upload Image", tabs: true },
    },
    [
      _c(
        "v-form",
        { ref: "form" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", xs: "12", sm: "6", lg: "4" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "soli-round" },
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-col",
                            { staticClass: "flex justify-center hidden" },
                            [
                              _c("input", {
                                ref: "photo",
                                attrs: { type: "file" },
                                on: {
                                  input: function ($event) {
                                    return _vm.convertPhoto($event)
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.errors.photo
                            ? _c(
                                "v-row",
                                { staticClass: "justify-center w-full my-1" },
                                [
                                  _c("small", { staticClass: "red--text" }, [
                                    _vm._v(_vm._s(_vm.errors.photo)),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { class: ["my-3 justify-center w-full"] },
                            [
                              _c(
                                "v-btn",
                                {
                                  class: ["soli-round"],
                                  attrs: {
                                    text: "",
                                    small: "",
                                    plain: "",
                                    color: "dark",
                                    type: "button",
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.selectNewPhoto.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "Upload Photo\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          staticClass: "soli-round",
          attrs: { "max-width": "425" },
          model: {
            value: _vm.showImageEditor,
            callback: function ($$v) {
              _vm.showImageEditor = $$v
            },
            expression: "showImageEditor",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "soli-round", staticStyle: { overflow: "hidden" } },
            [
              _vm.cropperLoading
                ? _c(
                    "v-container",
                    [
                      _c("v-skeleton-loader", {
                        staticClass: "soli-round",
                        attrs: { type: "image" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("VueCropper", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.cropperLoading,
                    expression: "!cropperLoading",
                  },
                ],
                ref: "cropper",
                attrs: { src: null, aspectRatio: 1, alt: "Loading" },
              }),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "pa-3",
                attrs: {
                  label: "Name",
                  "hide-details": "",
                  outlined: "",
                  dense: "",
                },
                model: {
                  value: _vm.photoForm.imageName,
                  callback: function ($$v) {
                    _vm.$set(_vm.photoForm, "imageName", $$v)
                  },
                  expression: "photoForm.imageName",
                },
              }),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        plain: "",
                        color: "soli-grey soli-round",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          _vm.closeModal(() => (_vm.showImageEditor = false))
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "soli-blue white--text soli-round",
                      attrs: { loading: _vm.imageLoading },
                      on: {
                        click: function ($event) {
                          _vm.updatePhoto(),
                            _vm.closeModal(() => (_vm.showImageEditor = false))
                        },
                      },
                    },
                    [_vm._v("Save")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showMessage
        ? _c("SoliSnack", {
            attrs: { text: _vm.$page.props.successMessage },
            on: {
              hide: function ($event) {
                _vm.showMessage = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }